import { useSelector } from 'react-redux';
import { useEffect } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
// import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';

// auth provider
import { JWTProvider } from 'contexts/JWTContext';

// Prismic provider
import { PrismicProvider } from '@prismicio/react';
import { client } from './prismic';

// ==============================|| APP ||============================== //

const App = () => {
    const customization = useSelector((state) => state.customization);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />

                <Locales>
                    <NavigationScroll>
                        <PrismicProvider client={client}>

                            <JWTProvider>
                                <>
                                    <Routes />
                                    <Snackbar />
                                </>
                            </JWTProvider>
                        </PrismicProvider>
                    </NavigationScroll>
                </Locales>

            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
